// @flow
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actions as OrderRequestsActions } from '../duck';
import { actions as AlertActions } from '../../alert/duck';
import PurchasesActives from '../components/PurchasesActives/PurchasesActives';

import type { RootState } from '../../index';

function mapStateToProps(state: RootState) {
  return {
    isFetchingActives: state.orders.isFetchingActives,
    localValues: state.localValues,
    activePurchases: state.orders.activePurchases,
    fetchActivesError: state.orders.fetchActivesError,
    isDeletingOrCancelingOrder: state.orders.isDeletingOrCancelingOrder,
    deleteOrCancelSuccess: state.orders.deleteOrCancelSuccess,
    deleteOrCancelOrderError: state.orders.deleteOrCancelOrderError,
  }
}

function mapDispatchToProps(dispatch: Function) {
  return bindActionCreators({ ...OrderRequestsActions, ...AlertActions }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(PurchasesActives);



// WEBPACK FOOTER //
// ./src/modules/orders/containers/PurchasesActivesContainer.js